import styled, { useTheme } from 'styled-components';

import { DocumentVideoUploadButton } from '@/component/FileUpload/DocumentVideoUploadButton';
import { Icon } from '@/ui/Icon';
import { useSelectedElementFloatingToolbar } from '@/component/customEditorV2/hooks/elementFloatingToolbar/useSelectedElementFloatingToolbar';
import { FloatingToolbarButtons } from '@/component/customEditorV2/ui/elements/ImageElement/Placeholder/FloatingToolbarButtons';

const RootStyled = styled.div`
  height: 440px;
  width: 100%;
  background: ${({ theme }) => theme.colors.neutral.container};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  border-radius: 12px;
`;

const TitleStyled = styled.h3`
  ${({ theme }) => theme.typography.title3};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

const UploadButton = styled(DocumentVideoUploadButton)`
  & {
    background: transparent;
  }
`;

export const Placeholder = ({
  shouldShowToolbar,
  onUpload,
  onRemove,
}: {
  shouldShowToolbar: boolean;
  onUpload: (file: File) => void;
  onRemove: () => void;
}): JSX.Element => {
  const theme = useTheme();

  const { setFloating, setReference, style } = useSelectedElementFloatingToolbar({ selected: shouldShowToolbar });

  return (
    <>
      <RootStyled ref={setReference}>
        <Icon size="3x" icon={['far', 'image']} color={theme.colors.neutral.onBackground} />
        <TitleStyled>Add image</TitleStyled>
        <UploadButton
          icon={['far', 'file-upload']}
          variant="secondary"
          size="large"
          disabled={false}
          uploadFile={onUpload}
          fileType={'image'}
        >
          Upload
        </UploadButton>
      </RootStyled>
      <div
        ref={setFloating}
        style={{
          ...style,
        }}
      >
        <FloatingToolbarButtons onRemoveClick={onRemove} />
      </div>
    </>
  );
};
